<div [class]="compact()?'count-down-timer-compact':'count-down-timer'">
  <div class="wrapper">
      <span class="mr-2"><span class="times primary-color" #days></span> @if(compact() && targetTime){<span class="compact-description">d</span>}</span>
      <span class="mx-2"><span class="times primary-color" #hours></span> @if(compact() && targetTime){<span class="compact-description">h</span>}</span>
      <span class="mx-2"><span class="times primary-color" #minutes></span> @if(compact() && targetTime){<span class="compact-description">m</span>}</span>
      <span class="ml-2"><span class="times primary-color" #seconds></span> @if(compact() && targetTime){<span class="compact-description">s</span>}</span> 
    @if(!compact() && targetTime){
        <p class="description">Days</p>
        <p class="description">Hours</p>
        <p class="description">Minutes</p>
        <p class="description">Seconds</p>
    }
  </div>
</div>
  